import Vue from 'vue'
import VueCookies from 'vue-cookies'
import router from '../../router'
import api from '../../api/leadRealAPI'

Vue.use(VueCookies)

export default {
  namespaced: true,

  state: {
    userData: null,
    PrePassword: null,
    clientName: null,
    clientMenu: {
      plan: null,
      properties: null,
      translation: null
    },
    currentEmail: null,
    myAccount: null,
    emailExist: false
  },

  getters: {
    user: state => state.userData,
    PrePassword: state => state.PrePassword,
    clientName: state => state.clientName,
    clientMenu: state => state.clientMenu,
    currentEmail: state => state.currentEmail,
    emailExist: state => state.emailExist,
    myAccount: state => state.myAccount
  },

  mutations: {
    setUserData (state, user) {
      state.userData = user
    },
    setPrePassword (state, PrePassword) {
      state.PrePassword = PrePassword
    },
    setName (state, clientName) {
      state.clientName = clientName
      state.clientMenu = clientName.menu
    },
    setCurrentEmail (state, currentEmail) {
      state.currentEmail = currentEmail
    },
    setMyAccount (state, myAccount) {
      state.myAccount = myAccount
    },
    setEmailExist (state, emailExist) {
      state.emailExist = emailExist
    }
  },

  actions: {
    getUserData ({ commit }) {
      api
        .get('user')
        .then(response => {
          commit('setUserData', response.data)
        })
        .catch(() => {
          Vue.$cookies.remove('access_token')
        })
    },
    getClientName ({ state, commit }) {
      api
        .get('/member/userFullName/')
        .then(response => {
          commit('setName', response.data.data)
        })
        .catch(() => {
          // Vue.$cookies.remove('access_token')
        }, 200)
    },
    sendLoginRequest ({ commit, dispatch }, data) {
      api
        .post('loginRequestAdmin/', data)
        .then(response => {
          if (response.data.message) {
            dispatch('getErrors', response.data.message, { root: true })
          }
          const account = {}
          const user = response.data.administrator
          account.userID = user.id
          account.type = 'Admin'
          commit('setUserData', user)
          this.state.wrong = null
          Vue.$cookies.set('access_token_admin', response.data.token, '1d')
          Vue.$cookies.set('account', JSON.stringify(account), '1d')
          if (response.data.administrator.role.name === 'posting_permission') {
            router.push({ name: 'Property List', params: { type: 'business' } }).catch(() => {})
          } else {
            router.push({ name: 'Admin Dashboard' }).catch(() => {})
          }
        }).catch(() => {})
    },
    sendLogoutRequest ({ commit }) {
      api.post('admin/log-out/').then(() => {
        commit('setUserData', null)
        Vue.$cookies.remove('access_token_admin')
        Vue.$cookies.remove('account')
        Vue.$cookies.remove('language')
        router.push({ name: 'Login' }).catch(() => {})
      })
    },
    sendLogoutRequestClient ({ commit }, language) {
      api.post('member/log-out/').then(() => {
        commit('setUserData', null)
        Vue.$cookies.remove('access_token_client')
        Vue.$cookies.remove('account')
        Vue.$cookies.remove('language')
        router.push({ name: 'Home', params: { lang: language } }).catch(() => {})
      })
    },
    preRegisteredClient ({ commit }, data) {
      api
        .post('memberPreRegister/', data.post)
        .then(response => {
          if (response.data.status === 'This email already register') {
            commit('setEmailExist', true)
          } else if (response.data.status === 'reCAPTCHA failed') {
            window.location.reload()
          } else {
            commit('setPrePassword', response.status)
            commit('setEmailExist', false)
            router.push({ name: 'Client Entry Thanks', params: { lang: data.language } }).catch(() => {})
          }
        }).catch(() => {})
    },
    myAccountAccount ({ commit }) {
      api
        .get('member/myAccount/')
        .then(response => {
          commit('setMyAccount', response.data.data)
        })
    },
    clientUpdate ({ commit }, data) {
      api
        .post('member/clientUpdate/', data)
        .then(response => {
          if (response.status === 200) {
            router.push({ name: 'Client Member Information Update' })
          }
        })
    },
    clientForgetPassword ({ commit }, data) {
      api
        .post('clientForgetPassword/', data)
        .then(response => {
          if (response.status === 200) {
            router.push({ name: 'Client Forgot Password Confirmation', params: { lang: router.currentRoute.params.lang } })
          }
        }).catch(() => {})
    },
    clientResetPassword ({ commit }, data) {
      api
        .post('password/reset/client/', data)
        .then(response => {
          if (response.status === 200) {
            router.push({ name: 'Client Reset Password Confirmation', params: { lang: router.currentRoute.params.lang } })
          }
        }).catch(() => {})
    },
    verifyTokenClient ({ commit }, data) {
      api.post('verifyTokenRoute/', data)
        .then(response => {
          if (response.status === 200) {
            router.push({ name: 'Client Reset Password', params: { lang: router.currentRoute.params.lang } })
            commit('setCurrentEmail', data.email_address)
          }
        }).catch((error) => {
          if (error) {
            router.push({ name: 'Client 404', params: { lang: router.currentRoute.params.lang } })
          }
        })
    },
    withdrawalClient ({ commit }, data) {
      api.post('member/deleteMember/' + data.id)
        .then(response => {
          if (response.status === 200) {
            router.push({ name: 'Client Withdrawal Completed' })
            Vue.$cookies.remove('access_token_client')
            Vue.$cookies.remove('account')
            Vue.$cookies.remove('language')
          }
        }).catch(() => {})
    },
    verifyMember ({ commit }, data) {
      api.post('memberRedirect/', data)
        .then(response => {
          if (response.data.token) {
            Vue.$cookies.set('access_token_client', response.data.token, '1d')
            router.push({ name: 'Client Entry Detail' })
          } else {
            router.push({ name: 'Client 404', params: { lang: router.currentRoute.params.lang } })
          }
        }).catch((error) => {
          if (error) {
            router.push({ name: 'Client 404', params: { lang: router.currentRoute.params.lang } })
          }
        })
    },
    loginClient ({ commit, dispatch }, data) {
      api.post('loginRequestClient/', data.account)
        .then(response => {
          if (response.data.message) {
            dispatch('getErrors', response.data.message, { root: true })
          }
          if (response.status === 200 || response.data.member.email_address_verified_at === 'verify') {
            const account = {}
            const user = response.data.member
            account.userID = user.email_address
            account.email_verify = user.email_address_verified_at
            account.type = 'Client'
            commit('setUserData', user)
            this.state.wrong = null
            Vue.$cookies.set('access_token_client', response.data.token, '1d')
            Vue.$cookies.set('account', JSON.stringify(account), '1d')
            if (data.lang === undefined) { data.lang = Vue.$cookies.get('language') }
            if (data.redirect) {
              router.push({ path: data.redirect })
            } else {
              router.push({ name: 'Client Property', params: { lang: data.lang } })
            }
          }
        }).catch(() => {})
    }
  }
}
